module.exports = __webpack_public_path__ + "img/ep-W.b9090862.jpg";